import { Info } from "@phosphor-icons/react";

import { tagVariants } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

export default function ScheduledChangeTag() {
  return (
    <Tooltip>
      <TooltipTrigger
        className={tagVariants({ variant: "yellow", icon: "right" })}
      >
        Scheduled change <Info weight="fill" />
      </TooltipTrigger>

      <TooltipContent>
        This subscription has a scheduled change which will be effective
        starting from your next billing date. Consult your account manager to
        know more
      </TooltipContent>
    </Tooltip>
  );
}
